import { useNavigate } from 'react-router-dom';
import { usePartial } from 'shared/hooks/utils';
import { isMediumUI } from 'shared/app/lib/choose-ui-type';
import { AccountDialogRoutes } from 'shared/account.settings/model/types';
export function useNavigateBack(options) {
    const navigate = useNavigate();
    return usePartial(navigate, -1, options);
}
export function useNavigateForward(options) {
    const navigate = useNavigate();
    return usePartial(navigate, 1, options);
}
export function useNavigateRoot() {
    const navigate = useNavigate();
    return usePartial(navigate, '/', { replace: true });
}
export function useNavigateTo(url, options) {
    const navigate = useNavigate();
    return usePartial(navigate, url, options);
}
export function useNavigateAccountDialog() {
    return useNavigateTo(`account${isMediumUI() ? `/${AccountDialogRoutes.details}` : ''}`, { state: { selected_tab: isMediumUI() ? AccountDialogRoutes.details : null } });
}
